import { render, staticRenderFns } from "./CancelSubmitForm6.vue?vue&type=template&id=b8007838&scoped=true"
import script from "./CancelSubmitForm6.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8007838",
  null
  
)

export default component.exports